import { useEffect, useState } from 'react';

const detectMobileSession = (): boolean => {
    const userAgent = navigator.userAgent;
    // Verifica se o userAgent corresponde a um dispositivo m�vel
    return /android|iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
};

/**
 * Detect if the app is running in a mobile browser and update if that changes (e.g. when switching to a mobile browser in a browser emulator)
 * @returns true if this detects the app is running in a mobile browser
 */
export const useIsMobile = (): boolean => {
    const [isMobileSession, setIsMobileSession] = useState<boolean>(detectMobileSession());

    useEffect(() => {
        const updateIsMobile = (): void => {
            setIsMobileSession(detectMobileSession());
        };

        // Ouvindo eventos de resize e orientationchange
        window.addEventListener('resize', updateIsMobile);
        window.addEventListener('orientationchange', updateIsMobile);

        return () => {
            window.removeEventListener('resize', updateIsMobile);
            window.removeEventListener('orientationchange', updateIsMobile);
        };
    }, []);

    return isMobileSession;
};